const resourceRoutes = [
	{
		path: "/resource/home",
		name: "resourceHome",
		component: () => import(/* webpackChunkName: "resourceHome" */ "@/views/resource/home/index.vue"),
		meta: {
			title: "开放资源",
			keepAlive: true,
		},
	},
];

export default resourceRoutes;
